import { useTranslation } from 'i18n';
import { useEffect } from 'react';
import { Switch } from 'ui';

import { useSegmentationComments } from '../../hooks/useSegmentationComments/useSegmentationComments';
import { useShowAiFeedback } from '../../hooks/useShowAiFeedback/useShowAiFeedback';

export const AiFeedbackSwitch = ({ evidenceId }: { evidenceId: number }) => {
  const { t } = useTranslation('features');
  const { setShowAiFeedback, showAiFeedback } = useShowAiFeedback();
  const { comments, isCommentsLoading } = useSegmentationComments(evidenceId, {
    enableFetch: true,
  });

  useEffect(() => {
    setShowAiFeedback(comments.length > 0 ? true : false);
  }, [comments, setShowAiFeedback]);

  return (
    <Switch
      label={t('annotations.aiFeedbackSwitch.label')}
      disabled={isCommentsLoading || comments.length === 0}
      checked={showAiFeedback}
      onChange={() => setShowAiFeedback(!showAiFeedback)}
    />
  );
};
